import styled from "styled-components";
import {Button} from "antd";

export const AssignPermissionPoliciesButton = styled(Button)`
    margin-bottom: 10px;
`;
